import { PlaceholderType, type PlaceholderWriteRequest } from '@/api/generated/schemas';
import type { PlaceholderFormValues } from './placeholderFormSchema';

function emptyToNull(value: string): string | null {
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : null;
}

/**
 * Mapuje hodnoty formuláře na API tělo zápisu placeholderu. Create i Update mají shodný tvar, takže
 * stačí jeden builder; formulář drží bohaté UI refy, API chce jen id. Ubytovací / dopravní pole se
 * odesílají jen pro odpovídající typ (jinak `null`/prázdné).
 */
export function toPlaceholderRequestBody(values: PlaceholderFormValues): PlaceholderWriteRequest {
  const isAccommodation = values.type === PlaceholderType.Accommodation;
  const isTransport = values.type === PlaceholderType.Transport;

  return {
    type: values.type,
    costType: values.costType,
    name: emptyToNull(values.name),
    subcategoryId: values.subcategory?.id ?? null,
    destinationId: values.destination?.destinationId ?? null,
    showInProgram: values.showInProgram,
    code: emptyToNull(values.code),
    note: emptyToNull(values.note),
    status: values.status,
    facilitySubTypeId: isAccommodation ? (values.facilitySubType?.id ?? null) : null,
    accommodationCategoryCbId: isAccommodation ? (values.accommodationCategory?.id ?? null) : null,
    unitPatterns: isAccommodation ? values.unitPatterns : [],
    equipmentIds: isAccommodation ? values.equipment.map((item) => item.id) : [],
    transportKind: isTransport ? values.transportKind : null,
  } satisfies PlaceholderWriteRequest;
}
